import { render } from "./SupportForm.vue?vue&type=template&id=ae2d741a&scoped=true"
import script from "./SupportForm.vue?vue&type=script&lang=js"
export * from "./SupportForm.vue?vue&type=script&lang=js"

import "./SupportForm.vue?vue&type=style&index=0&id=ae2d741a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae2d741a"]])

export default __exports__